<template>
	<div class="sharing">
		<div class="icons">
			<ShareNetwork network="facebook" :url="link" :title="title" hashtags="CobraTicket">
				<div class="btn btn-facebook"><i class="icon icon-social-facebook"></i></div>
			</ShareNetwork>
			<ShareNetwork network="twitter" :url="link" :title="title" hashtags="CobraTicket">
				<div class="btn btn-twitter"><i class="icon icon-social-twitter"></i></div>
			</ShareNetwork>
			<ShareNetwork network="whatsapp" :url="link" :title="title">
				<div class="btn btn-whatsapp"><i class="icon icon-social-whatsapp-outline"></i></div>
			</ShareNetwork>
		</div>
	</div>
</template>
<script>
export default {
	name: "ShareButtons",

	props: {
		link: {
			type: String,
			required: true
		},
		title: {
			type: String,
			required: true
		}
	},
	data() {
		return {}
	}
}
</script>
<style scoped lang="scss">
.sharing {
	width: 100%;

	.icons {
		display: flex;
		align-items: center;
		justify-content: flex-start;
		flex-direction: column;
		gap: 8px;

		.btn {
			width: 36px;
			height: 36px;
			background-color: transparent;
			transition: all 0.3s;
			border-radius: 24px;
			border-color: #e6e6e6;

			.icon {
				width: 32px;
				height: 32px;
				font-size: 20px;
			}

			&.btn-facebook:hover {
				color: #3b5998 !important;
				border-width: 2px;
				border-color: #3b5998 !important;
			}
			&.btn-whatsapp:hover {
				border-width: 2px;
				border-color: #25d366 !important;
				color: #25d366 !important;
			}
			&.btn-twitter:hover {
				border-width: 2px;
				border-color: #1da1f2 !important;
				color: #1da1f2 !important;
			}
		}
	}

	.input {
		flex-grow: 1;
		display: flex;
		align-items: center;
		height: 50px;
		padding: 0px 12px;
	}
}
</style>
